import React from 'react';
import styled from 'styled-components';
import { navigate } from 'gatsby';
import Button from '@ingka/button';
import variables from '@ingka/variables/design-tokens';
import { useTranslation } from '@ikea-customer-self-serve/gatsby-plugin-translations';
import { useCart } from '../contexts/Cart';
import { useCartHeight } from '../hooks/useCartHeight';
import { CartItemDisplay } from './CartItemDisplay';
import TMarkUp from './TMarkUp';
import cssIngka from '@ingka/variables/colours-css';

const InCartLayout = styled.div`
  display: flex;
  flex-direction: column;
  ${`@media (min-width: ${variables.breakpointM}) {
      width: 400px;
  }`}

  ${`@media (max-width: ${variables.breakpointM}) {
      display: none;
  }`}
`;
const InCartLayoutTitle = styled.h2.attrs({ as: 'h2', className: 'h2' })`
  flex-shrink: 0;
  margin: 167px 0 40px;
  margin-top: 24px;
  line-height: 50px !important;
`;
const StyledButtonWrapper = styled.div`
  flex-shrink: 0;
  border-top: 1px solid ${cssIngka.colourNeutral3};
  padding-top: 40px;
`;
const StyledItems = styled.ul`
  flex-grow: 1;
  overflow-y: auto;
`;

const InCart = ({
  isAutoResize = true,
}: {
  isAutoResize: boolean;
}): JSX.Element | null => {
  const { t } = useTranslation();
  const CartContext = useCart();
  const height = useCartHeight(100);

  const items = Array.from(
    CartContext.state.items.values()
  ).map(({ item, quantity }) => (
    <CartItemDisplay key={item.id} item={item} quantity={quantity} />
  ));
  const onClickNext = (): void => {
    navigate(`/customer-information/`);
  };

  if (!items.length) {
    return null;
  }

  const inCartLayoutStyle = {
    height,
  };

  return (
    <InCartLayout style={isAutoResize ? inCartLayoutStyle : {}}>
      <InCartLayoutTitle>
        <TMarkUp value={t('spareParts.orderList')} />
      </InCartLayoutTitle>
      <StyledItems>{items}</StyledItems>
      <StyledButtonWrapper>
        <Button type="emphasised" onClick={onClickNext} fluid>
          <TMarkUp value={t('spareParts.orderSpareParts')} />
        </Button>
      </StyledButtonWrapper>
    </InCartLayout>
  );
};

export default InCart;
